<template>

</template>

<script>
export default {
  data() {
    return {
      token: this.$route.query.token,
      method: this.$route.query.method,
      redirectUri: this.$route.query.redirectUri
    };
  },
  created() {
    if (!this.method) {
       this.$router.push('/404')
    }
    if (!this.redirectUri) {
       this.$router.push('/404')
    }
    if (this.token) {
      this.jumpHandler();
    } else {
      this.$router.push('/404')
    }
  },
  methods: {
    jumpHandler() {
      var params = {
        token: this.token,
        method: this.method,
        redirectUri: this.redirectUri
      };
      this.$get("/userjump/"+ this.method, params).then(response => {
        debugger
        if (response.code === 0) {
         // let path = window.location.protocol +  "//" + this.redirectUri;
          window.location.href = this.redirectUri
        }
        if (response.code === 107) {
          var url = response.msg
          window.location.href = url
        }
      });
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/common/JumpPage.vue